// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AuthenticationResponseType;
(function (AuthenticationResponseType) {
    AuthenticationResponseType[AuthenticationResponseType["Success"] = 0] = "Success";
    AuthenticationResponseType[AuthenticationResponseType["Error"] = 1] = "Error";
})(AuthenticationResponseType || (AuthenticationResponseType = {}));
